import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RadarIcon(props: IconProps) {
    return <Icon {...props} iconKey={"radar"}/>
}
